import { useLayoutStore } from "@/roc/stores/LayoutStore";
import Grid from "@/roc/grid/Grid";
export function updateLayoutForGridSizeChange(layout) {
    if (layout.grid.x === Grid.CELL_COUNT_X) {
        return;
    }
    const lytStore = useLayoutStore();
    if (layout.grid.x === null) {
        let layoutGridWidth = 0;
        for (let i = 0; i < layout.buildings.length; i++) {
            const template = lytStore.getBuildingTemplateById(layout.buildings[i].id);
            if (null !== template) {
                const rightEdge = layout.buildings[i].tileX + (layout.buildings[i].rotate ? template.height : template.width);
                if (rightEdge > layoutGridWidth) {
                    layoutGridWidth = rightEdge;
                }
            }
        }
        if (layoutGridWidth >= Grid.CELL_COUNT_X) {
            return;
        }
        layout.grid.x = layoutGridWidth;
    }
    const diffX = Grid.CELL_COUNT_X - layout.grid.x;
    for (let i = 0; i < layout.buildings.length; i++) {
        layout.buildings[i].tileX += diffX;
    }
    for (let i = 0; i < layout.expansions.length; i++) {
        layout.expansions[i].x += diffX;
    }
    for (let x = 0; x < diffX; x += Grid.EXPANSION_SIZE) {
        for (let y = 0; y < Grid.CELL_COUNT_Y; y += Grid.EXPANSION_SIZE) {
            layout.expansions.push({ x, y });
        }
    }
}
